
<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Event & Tips Hashtag List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                  color="primary"
                  class="float-left mb-2 ml-3"
                  @click="corporateActionHashtagCreate"
              >Create</CButton
              >
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                      class="float-left mb-0 mr-2"
                      placeholder="Search By Coporate Action Title"
                      @input="searchCorporateAction($event, '')"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
              hover
              striped
              :items="items"
              :fields="fields"
              :items-per-page="100"
              clickable-rows
              :active-page="1"
              :pagination="false"
              @page-change="pageChange"
          >
            <template #corporate_action_hashtag_ids="data">
              <td>
                <div class="button-table">
                  <CButton
                      color="primary"
                      class="mb-0 mr-0"
                      @click="rowClicked(data.item.corporate_action_hashtag_id)"
                  >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
                class="pagination-btn-refresh"
                @click="searchCorporateAction('', 'REFRESH')"
            >
              Refresh
            </div>
            <div
                class="pagination-btn-back"
                @click="searchCorporateAction('', 'BACK')"
            >
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div
                class="pagination-btn-next"
                @click="searchCorporateAction('', 'NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import moment from "moment";

export default {
  name: "corporate",
  data() {
    return {
      items: [],
      fields: [
        { key: "corporate_action_hashtag_id", label: "ID" },
        { key: "corporate_action_hashtag_title", label: "Title" },
        { key: "status" },
        { key: "corporate_action_hashtag_ids", label: "Action" },
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.searchCorporateAction("", "");
  },

  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    getBadge(status) {
      switch (status) {
        case "NEW":
          return "success";
        case "FOLLOW UP":
          return "secondary";
      }
    },
    searchCorporateAction(event, action) {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }
      axios
          .get(
              `${this.domain}/v1/corporate_action_hashtag/data?page=${this.activePage}&per_page=20&q=${event}`,
              {
                headers: {
                  Authorization: this.token,
                  "Content-Type": "application/json",
                },
              }
          )
          .then((response) => {
            if (response.data.data.length > 0) {
              if (this.activePage > 1) {
                window.scrollTo(0, 0);
              }
              this.items = response.data.data;
              this.items.forEach((element) => {
                element.active_date = moment(String(element.active_date)).format(
                    "MM/DD/YYYY hh:mm A"
                );
              });
            } else if (action === "NEXT") {
              this.activePage = this.activePage - 1;
            } else if (response.data.data.length === 0 && action === "") {
              this.items = response.data.data;
            }
          })
          .catch((e) => {
            console.log(e);
          });
    },
    rowClicked(item) {
      this.$router.push({ path: `/management/corporate-hashtag/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    corporateActionHashtagCreate() {
      this.$router.push({ path: `/management/corporate-hashtag/create` });
    },
  },
};
</script>

<style scoped>
@import url("./CorporateHashtag.css");
</style>
